export function firstLetter(string: string) {
  return string.match(/\b(\w)/g)?.join('')
}
